"use client";

import { getAvailableEsimsForTopup } from "@/services/purchase/purchaseApis";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { queryKeys } from "@/constants/queries.keys";
import { AvailableEsim } from "@/types/purchase/AvailableEsimsForTopup";

export function useAvailableEsimsForTopup(enabled: boolean) {
  const locale = useLocale();

  return useQuery<AvailableEsim[]>({
    queryKey: [queryKeys.purchase.availableEsimsForTopup],
    queryFn: async () => {
      const res = await getAvailableEsimsForTopup({ locale });
      if (!res.status) {
        throw new Error(res.message);
      }
      return res.data;
    },
    enabled,
  });
}

export function useAvailableEsimsForTopupMutation() {
  const locale = useLocale();

  return useMutation<AvailableEsim[]>({
    mutationFn: async () => {
      const res = await getAvailableEsimsForTopup({ locale });
      if (!res.status) {
        throw new Error(res.message);
      }
      return res.data;
    },
  });
}
